import LoginInformation from './LoginInformation.router';
import LoginInformationRoutes from './LoginInformation.routes';

export { LoginInformationRoutes };

export default LoginInformation;
